import { parseJsonSafe } from 'util/misc'
import type { PostFetchGuard } from '../types'
import {
  AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2,
  parseMinimumVoltageFromFilterValue,
} from '../../../../hardwareFilter/acVoltageRating/constants'

type FetchedComponent = {
  data?: string
  voltage_rating?: number | string
  other?: { voltage_rating?: number | string }
}

const getComponentVoltageRating = (component: FetchedComponent): number | null => {
  const componentDataParsed = parseJsonSafe(component?.data) as FetchedComponent | null
  const voltageRatingRaw =
    component?.voltage_rating ?? componentDataParsed?.voltage_rating ?? component?.other?.voltage_rating
  const voltageRating = Number(voltageRatingRaw)
  return Number.isFinite(voltageRating) ? voltageRating : null
}

export const acIsolatorVoltageBucketPostFetchGuard: PostFetchGuard = ({ componentsData, allFilterValues }) => {
  const selectedTypesRaw = allFilterValues?.types
  const currentType = allFilterValues?.current_type

  const selectedTypes = (() => {
    if (selectedTypesRaw instanceof Set) return selectedTypesRaw
    if (typeof selectedTypesRaw === 'string') {
      const parsed = parseJsonSafe(selectedTypesRaw)
      return new Set(Array.isArray(parsed) ? parsed : [])
    }
    return new Set()
  })()

  const isACIsolatorFlow = selectedTypes.has('isolator') && currentType === 'ac'
  if (!isACIsolatorFlow) return componentsData || []

  const filterValueRaw = allFilterValues?.[AC_VOLTAGE_RATING_BUCKET_FILTER_KEY_V2]
  let minimumVoltage: number

  if (typeof filterValueRaw === 'string') {
    const parsed = parseJsonSafe(filterValueRaw)
    minimumVoltage = parseMinimumVoltageFromFilterValue(
      Array.isArray(parsed) ? parsed[0] : filterValueRaw
    )
  } else {
    minimumVoltage = parseMinimumVoltageFromFilterValue(filterValueRaw)
  }

  if (minimumVoltage <= 0) return componentsData || []

  return (componentsData || []).filter((component: FetchedComponent) => {
    const voltageRating = getComponentVoltageRating(component)
    if (voltageRating === null) return true
    return voltageRating >= minimumVoltage
  })
}
